<!--<ig-accordion #accordion [mode]="mode" [title]="title" class="event-date-filter" [menuClass]="menuClass"-->
<!--  (onIconClicked)="clear()">-->
<!--  <ng-container expand>-->
<!--    <ng-container *ngTemplateOutlet="eventDateFilter">-->
<!--    </ng-container>-->
<!--  </ng-container>-->

<!--  <ng-container dropdown>-->
<!--    <ng-container *ngTemplateOutlet="eventDateFilter">-->
<!--    </ng-container>-->
<!--  </ng-container>-->

<!--  <ng-template #eventDateFilter>-->

<!--    <button mat-menu-item (click)="changeFilter()">ALL</button>-->
<!--    <button *ngFor="let btn of locationFilter$ | async" mat-menu-item-->
<!--      (click)="changeFilter(btn)">{{btn.locality}}</button>-->
<!--  </ng-template>-->
<!--</ig-accordion>-->

<button 
  mat-button 
  #trigger="matMenuTrigger" 
  [matMenuTriggerFor]="groups" 
  (menuOpened)="menuOpened(trigger)"
  [matRippleCentered]="true" 
  matRipple 
  [matRippleColor]="'rgba(255, 255, 255, 0.1)'"
  [class.accordion-selected]="isItemSelected"
  [attr.aria-haspopup]="'menu'"
  [attr.aria-expanded]="isMenuOpened"
  [attr.aria-label]="'Filter by location: ' + (displayTitle || 'All locations')"
  (keydown.arrowDown)="$event.preventDefault(); focusFirstMenuItem()"
  (keydown.enter)="$event.preventDefault()"
  (keydown.space)="$event.preventDefault(); trigger.toggleMenu()">
  
  <span>{{ displayTitle || 'FILTER BY LOCATION' }}</span>
  <mat-icon 
    class="mat-icon notranslate" 
    [attr.aria-hidden]="true" 
    (click)="iconClick($event)"
    [attr.aria-label]="isItemSelected ? 'Clear filter' : (isMenuOpened ? 'Collapse menu' : 'Expand menu')">
    {{ isItemSelected ? 'clear' : isMenuOpened ? 'expand_more' : 'chevron_left' }}
  </mat-icon>
</button>

<mat-menu 
  #groups="matMenu" 
  class="ig-place-location-filter-menu" 
  (closed)="onMenuClosed()"
  (opened)="onMenuOpened()"
  xPosition="before"
  [overlapTrigger]="false">
  
  <button 
    mat-menu-item 
    (click)="selectAll()"
    (keydown.enter)="selectAll()"
    (keydown.space)="selectAll(); $event.preventDefault()"
    [attr.aria-selected]="!isItemSelected"
    role="menuitemradio">
    ALL
  </button>

  @if (locationFilterGroups) {
    @if (!locationFilterGroups.isCityLevelFilter) {
      @for (group of locationFilterGroups.eventGroups; track group) {
        <button 
          mat-menu-item 
          (click)="selectGroup(group)"
          (keydown.enter)="selectGroup(group)"
          (keydown.space)="selectGroup(group); $event.preventDefault()"
          [attr.aria-selected]="isGroupSelected(group)"
          role="menuitemradio">
          {{ group.title }}
        </button>
      }
    } @else {
      @for (group of locationFilterGroups.eventGroups; track group) {
        <ng-container>
          <button 
            type="button" 
            mat-menu-item 
            #trigger="matMenuTrigger"
            [matMenuTriggerFor]="(group.cities.length == 1 && group.title == group.cities[0]) ? null : tabledriven"
            class="top-bar-font-size" 
            [class.filtering]="false" 
            (click)="selectTopGroup(group)"
            (keydown.enter)="selectTopGroup(group)"
            (keydown.space)="selectTopGroup(group); $event.preventDefault()"
            [attr.aria-haspopup]="group.cities.length > 1"
            [attr.aria-expanded]="isSubMenuOpen(group)"
            [attr.aria-selected]="isGroupSelected(group)"
            role="menuitem"
            [attr.aria-label]="group.title + (group.cities.length > 1 ? ' (has submenu)' : '')">
            {{ group.title || 'FILTER BY CATEGORY' }}
          </button>

          <mat-menu 
            #tabledriven="matMenu" 
            class="ig-nested-menu"
            (closed)="onSubMenuClosed(group)"
            (opened)="onSubMenuOpened(group)">
            
            @if (group.cities.length > 1) {
              <button 
                mat-menu-item 
                (click)="selectGroup(group)"
                (keydown.enter)="selectGroup(group)"
                (keydown.space)="selectGroup(group); $event.preventDefault()"
                [attr.aria-selected]="isGroupSelected(group)"
                role="menuitemradio">
                ALL
              </button>
            }
            
            @for (city of group.cities; track city) {
              <button 
                mat-menu-item 
                (click)="selectCity(city)"
                (keydown.enter)="selectCity(city)"
                (keydown.space)="selectCity(city); $event.preventDefault()"
                [attr.aria-selected]="isCitySelected(city, group)"
                role="menuitemradio">
                {{ city }}
              </button>
            }
          </mat-menu>
        </ng-container>
      }
    }
  }
</mat-menu>